import * as types from "./actionTypes";

export const editingToggle = (field, entity) => ({
  type: types.EDITING_TOGGLE,
  field,
  entity
});

export const fetchEdits = (data, id, entity) => ({
  type: types.FETCH_EDITS,
  data,
  id,
  entity
});



// WEBPACK FOOTER //
// ./src/modules/editing/actions.js